import React from 'react';
import FillAppField from 'components/FillAppField';
import {
    type FillAppField as FieldDef,
    type FillAppRepeatingGroup,
    type ChoiceGroups,
    type FillAppValues,
    fieldIsVisible,
    resolveShowWhen,
    groupActiveSlots,
} from 'global/fillapp';

import './index.css';

type Props = {
    group: FillAppRepeatingGroup;
    fieldsByQid: Record<string, FieldDef>;
    values: FillAppValues;
    choiceGroups: ChoiceGroups;
};

function titleCase(s: string): string {
    return s.charAt(0).toUpperCase() + s.slice(1);
}

// Read-only tutor view: renders shared fields + the active entry slots only.
function RepeatingGroup({ group, fieldsByQid, values, choiceGroups }: Props) {
    const gateOk = !group.gate || resolveShowWhen(group.gate, values);
    const active = groupActiveSlots(group, values);

    const renderField = (qid: string) => {
        const field = fieldsByQid[qid];
        if (!field || !fieldIsVisible(field, values)) return null;
        return (
            <FillAppField
                key={qid}
                field={field}
                value={values[qid]}
                values={values}
                choiceGroups={choiceGroups}
                readOnly
            />
        );
    };

    return (
        <div className='rgroup'>
            {group.sharedQids.map(renderField)}
            {gateOk && Array.from({ length: active }).map((_, i) => (
                <div key={i} className='rgroup__slot'>
                    <div className='rgroup__slotTitle'>
                        {titleCase(group.label)} {i + 1}
                    </div>
                    {(group.slots[i] || []).map(renderField)}
                </div>
            ))}
            {gateOk && group.softMax != null && active > group.softMax && (
                <div className='rgroup__softMaxNote'>
                    {active} of {group.softMax} — over the Common App limit (drafting extras to choose from)
                </div>
            )}
            {gateOk && group.trailingSharedQids.map(renderField)}
        </div>
    );
}

export default RepeatingGroup;
